import * as React from 'react';

import { ArrowIcon } from 'shared/newComponents/icons';
import { IconSize } from 'shared/entities/components/Icon';

import './Arrow.modules.scss';

type Props = {
  className?: string;
};

const Arrow: React.FC<Props> = ({ className }: Props) => {
  return (
    <ArrowIcon iconSize={IconSize.S} styleName="arrow" className={className} />
  );
};

export default React.memo(Arrow);
